import React from 'react';
import { Select, SelectProps } from 'antd-v5';
import clas from 'classnames';

interface Props extends SelectProps {
    className?: string;
}

const RecallSelect: React.FC<Props> = ({ className, ...props }) => {
    return <Select className={clas(className, 'recall-select')} {...props} />;
};
export default RecallSelect;
